import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ImportFilesDialogComponent } from './import-files-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ImportFilesDialogService {

  constructor(private modalService: NgbModal) { }

  public confirm(
    title: string,
    message: string,
    url: string,
    dialogSize: 'sm' | 'lg' = 'sm'): Promise<boolean> {
    const modalRef = this.modalService.open(ImportFilesDialogComponent, { size: dialogSize });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.url = url;
    return modalRef.result;
  }

  public confirm1(
    title: string,
    message: string,
    url: string,
    companyId:number,
    dialogSize: 'sm' | 'lg' = 'sm'): Promise<boolean> {
    const modalRef = this.modalService.open(ImportFilesDialogComponent, { size: dialogSize });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.url = url;
    modalRef.componentInstance.companyId = companyId; 
    return modalRef.result;
  }
}
